<script>
import { get, sync } from 'vuex-pathify'
export default {
	data() {
		return {
			hasMounted: false, // fix render mismatch
		}
	},
	computed: {
		showCartAutoRemovals: sync('cart/showCartAutoRemovals'),
		cartAutoRemovals: get('cart/cartAutoRemovals'),
		cartDrawer: sync('shop/cartDrawer'),
		noCartButton() {
			return this.$route.name.includes('checkout')
		},
	},
	methods: {
		showCart() {
			this.showCartAutoRemovals = false
			this.cartDrawer = true
		},
	},
	mounted() {
		this.hasMounted = true
	},
}
</script>

<template>
	<v-dialog v-if="hasMounted" v-model="showCartAutoRemovals" max-width="600px" persistent>
		<v-card class="pa-4">
			<v-list-item class="px-0">
				<div class="font-weight-bold font-3 header">Hubo cambios en tu carrito</div>
				<v-spacer></v-spacer>
				<Button icon color="link" @click="showCartAutoRemovals = false" large>
					<v-icon color="link">mdi-close</v-icon>
				</Button>
			</v-list-item>
			<v-divider />
			<div>
				<div class="my-2">
					Algunos productos de tu carrito han sido removidos o sus cantidades han cambiado.
				</div>
				<div v-for="(item, n) of cartAutoRemovals" :key="n" class="item rounded d-flex align-center mt-2">
					<Media :src="item.image" width="90px" />
					<div>
						<div class="mb-2">{{ item.name }}</div>
						<div class="font-0">
							<span class="px-1" style="text-decoration: line-through">{{ item.oldQty }}</span>
							<v-icon small>mdi-arrow-right</v-icon>
							<span class="px-1">{{ item.qty }}</span>
							<span class="error white--text rounded pa-1">
								{{ item.qty ? `Se removieron: ${item.removedQty} ${item.unitMetric}` : 'Eliminado' }}
							</span>
						</div>
					</div>
				</div>
			</div>
			<v-card-actions v-if="!noCartButton" class="d-flex justify-end">
				<Button @click="showCart" color="cta"><div>Ver carrito</div></Button>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<style lang="scss" scoped>
.item {
	background: #f8f9fa;
	border-left: 5px solid var(--cta);
}
</style>

